// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5E2DJ","fullView":"styles_fullView__2wvU5"};